import React from "react";
import { Link } from "react-router-dom";
import { AppButtonSmall } from "../utils";

// function truncateString(str, num) {
//   if (str.length > num) {
//     return str.slice(0, num) + "...";
//   } else {
//     return str;
//   }
// }

function CardImg({ title, body, src, link }) {
  return (
    <div className="" style={{ width: 350 }}>
      <img
        src={src}
        className="mb-8 transform hover:scale-110 transition duration-500 rounded-3xl h-64 w-256 object-cover shadow-xl "
        alt="eventpic"
      />

      <div className="text-center">
        <h5 className="text-xl font-semibold mb-2">{title}</h5>

        <p className="mb-4 font-josefin">{body}</p>
        <Link to={`details/${link}`}>
          <AppButtonSmall text="Read More" />
        </Link>
      </div>
    </div>
  );
}

export default CardImg;
